const Routes = [
  {
    path: '/purchase_orders',
    name: 'PurchaseOrders',
    component: () => import('@/app/purchase_orders/ThePurchaseOrders'),
    redirect: '/purchase_orders/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/purchase_orders/views/Index')
      }
    ]
  },
  {
    path: '/comercionet_purchase_orders',
    name: 'ComercionetPurchaseOrders',
    component: () => import('@/app/purchase_orders/views/ComercionetPurchaseOrders')
  }

]
export default Routes



// WEBPACK FOOTER //
// ./src/app/purchase_orders/Routes.js